import { gql, useQuery } from '@apollo/client';
import { SoftwarePlanStatusesEnum } from '@thinknet-gmbh/platform-common';

export const GET_SOFTWARE_PLANS_FOR_MODULE = gql`
  query getSoftwarePlansForModule($status: SoftwarePlanStatusesEnum) {
    getSoftwarePlansForModule(status: $status) {
      _id
      currency
      name
      description
      refModuleName
      baseFeature {
        _id
        name
        pricesByRanges {
          annualPrice
          monthlyPrice
          customerRange
        }
      }
      additionalFeatures {
        _id
        name
        pricesByRanges {
          annualPrice
          monthlyPrice
          customerRange
        }
      }
    }
  }
`;

export const useGetSoftwarePlansForModule = () => {
  const { data, loading } = useQuery(GET_SOFTWARE_PLANS_FOR_MODULE, {
    variables: { status: SoftwarePlanStatusesEnum.ACTIVE },
  });

  const softwarePlans = data?.getSoftwarePlansForModule || [];

  return { loading, softwarePlans };
};
